import { twMerge } from 'tailwind-merge'
import { GInputProps } from './types'

export const GInput = (props: GInputProps) => {
	const {
		onChange: handleChange,
		label,
		helpText,
		error,
		type = 'text',
		icon: Icon,
		errorClassName,
		errorPosition,
		inputClassName,
		labelClassName,
		className,
		ref,
		id,
		value,
		checked,
		tagLabel,
		prefix,
		prefixClassName,
		borderError,
		errorIcon: ErrorIcon,
		errorIconClassName,
		...rest
	} = props

	return (
		<div className={`${className} relative`}>
			{label && (
				<label
					htmlFor={label}
					className={`text-left block ${
						labelClassName || 'text-t-base-blue mb-1 text-md font-medium'
					}`}
				>
					{label}
				</label>
			)}
			<div className="rounded-lg relative">
				<input
					ref={ref}
					type={type}
					className={twMerge(
						'bg-transparent border-t-gray-input disabled:bg-gray-100 focus:ring-0 focus:border-primary-500 block rounded-lg',
						'font-medium placeholder:text-t-secondary w-full',
						'appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none',
						inputClassName,
						Icon ? 'pl-10' : '',
						prefix ? 'pl-7 relative' : '',
						borderError && error ? 'border-red-500 ' : 'border-t-radio'
					)}
					onChange={(e) => handleChange(e)}
					checked={checked}
					{...(rest || {})}
					value={value}
					id={id}
				/>
				{prefix && (
					<span className={`absolute ${prefixClassName || ''}`}>{prefix}</span>
				)}
				{ErrorIcon && error && (
					<div
						className={`absolute ${errorIconClassName} inset-y-0 right-0 pr-3 flex items-center pointer-events-none`}
					>
						<ErrorIcon className="h-4 w-4 text-red-500" aria-hidden="true" />
					</div>
				)}
				{tagLabel && (
					<span className="absolute bg-gray-100 h-[33px] inset-y-0 px-4 py-2 right-0">
						{tagLabel}
					</span>
				)}
				{Icon && (
					<div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
						<Icon className="h-4 w-4 text-gray-400" aria-hidden="true" />
					</div>
				)}
				{errorPosition === 'flex' && error && (
					<p
						className={twMerge(
							'mt-1 text-xs text-red-700 bottom-[-15px]',
							errorClassName
						)}
						id="email-description"
					>
						{error}
					</p>
				)}
			</div>
			{!errorPosition && error && (
				<p
					className={twMerge('mt-1 text-xs text-red-700', errorClassName)}
					id="email-description"
				>
					{error}
				</p>
			)}
			{errorPosition === 'absolute' && error && (
				<p
					className={twMerge('absolute text-xs text-red-500', errorClassName)}
					id="email-description"
				>
					{error}
				</p>
			)}
			{helpText && (
				<p className="mt-2 text-sm text-t-secondary" id="email-description">
					{helpText}
				</p>
			)}
		</div>
	)
}
